import React, { MouseEvent } from 'react';
import {
  Btn,
} from './Styles';

const Button = React.forwardRef<any, Props>((({
  children,
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  paddingLeft,
  paddingRight,
  borderRadius,
  backgroundColor,
  border,
  marginLeft,
  marginTop,
  marginRight,
  marginBottom,
  onClick,
  disabled,
  activeOpacity,
  hoverOpacity,
  style,
  type,
  boxShadow,
}, ref) => {
  return (
    <Btn
      type={type}
      activeOpacity={activeOpacity}
      hoverOpacity={hoverOpacity}
      ref={ref}
      style={{ width, minWidth, maxWidth, height, minHeight, maxHeight, paddingLeft, paddingRight, borderRadius, backgroundColor, border, marginLeft, marginTop, marginRight, marginBottom, boxShadow, ...style }}
      onClick={(event) => {
        if (onClick) {
          onClick(event);
        }
      }}
      disabled={disabled}
    >
      {children}
    </Btn>
  );
}));

interface Props {
  children?: React.ReactNode;
  width?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  height?: number | string;
  minHeight?: number | string;
  maxHeight?: number | string;
  paddingLeft?: number | string;
  paddingRight?: number | string;
  backgroundColor?: string;
  borderRadius?: number | string;
  border?: string;
  marginLeft?: number;
  marginTop?: number;
  marginRight?: number,
  marginBottom?: number,
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  activeOpacity?: number;
  hoverOpacity?: number;
  style?: React.CSSProperties;
  type?: "submit" | "reset" | "button" | undefined;
  boxShadow?: string;
}

export default Button;
